import moment from 'moment';

export class SearchCondition {
  aggregated_at_from: string
  aggregated_at_to: string
  page: number = 1
  row_count: number =  20
}

export class ScoreChangeLog {
  sheet_id: number
  sheet_code: string
  sheet_name: string
  room_name: string
  class_name: string
  student_code: number
  student_name: string
  before_score: number
  after_score: number
  aggregated_at: string
  capture_date: string
  full_count: number

  constructor(x: any){
    this.sheet_id = x.sheet_id;
    this.sheet_code = x.sheet_code;
    this.sheet_name = x.sheet_name;
    this.room_name = x.room_name;
    this.class_name = x.class_name;
    this.student_code = x.student_code;
    this.student_name = x.student_name;
    this.before_score = x.before_score;
    this.after_score = x.after_score;
    this.aggregated_at = moment(x.aggregated_at).format('Y年M月D日 HH時mm分');
    this.capture_date = moment(x.capture_date).format('Y年M月D日');
    this.full_count = x.full_count;
  }
}